<div class="mb-3 mt-1 mt-md-2 mb-md-4">
    <app-timeline
        [steps]="steps"
        [currentStep]="tab"
        [allowAllSteps]="mode === FormMode.VIEW || !!activeRequest"
        (stepChange)="onTimelineStepClick($event)">
    </app-timeline>
</div>

<div class="panel mb-4"
     [class.p-2]="!appSettings.isMobile() && tab !== 3"
     [class.panel-docs-mobile]="appSettings.isMobile() && tab === 3">
    @if (!appSettings.isMobile()) {
        <div class="step-header d-flex align-items-center justify-content-between gap-3">
            <h5 class="mb-0 text-dark fw-bold text-nowrap">
                @if (tab === 1) {
                    <i class="fas fa-user me-2 text-primary"></i>
                }
                @if (tab === 2) {
                    <i class="fas fa-car me-2 text-primary"></i>
                }
                @if (tab === 3) {
                    <i class="fas fa-id-card me-2 text-primary"></i>
                }
                {{ stepTitle }}
            </h5>
        </div>
    }

    <div class="step-body">
        @if (tab === 1 && partyForm) {
            <app-party-form [partyForm]="partyForm" [mode]="mode" (formChange)="submitParty(tab)">
            </app-party-form>
        }

        @if (tab === 2 && vehicleForm) {
            <app-vehicle-form [vehicleForm]="vehicleForm" [mode]="mode" (formChange)="submitVehicle(tab)">
            </app-vehicle-form>
        }

        @if (tab === 3 && documents) {
            @if (useDocumentApproval) {
                <app-document-approval
                    [categoriesData]="documents?.categories"
                    [canApprove]="canApproveDocuments"
                    [canFinalApprove]="canFinalApproveDocuments"
                    [canReplace]="canReplaceObservedDocs"
                    (onReviewCompleted)="refreshDocuments()"
                    (onUploadFile)="uploadDocumentFile($event)">
                </app-document-approval>
            } @else if (documents?.categories?.length) {
                <app-document-group
                    [documents]="documents"
                    [mode]="FormMode.EDIT"
                    [immediateUpload]="true"
                    [layout]="'table'"
                    [embedded]="true"
                    (onUploadFile)="uploadDocumentFile($event)"
                    (onDocumentUpdate)="refreshDocuments()"
                    (onDeleteDocument)="deleteComplementaryDocument($event)">
                </app-document-group>
            } @else {
                <div class="text-center text-muted py-4 bg-light rounded border border-dashed">
                    <i class="fas fa-folder-open fs-2 mb-3 text-secondary d-block"></i>
                    <p class="m-0 fw-semibold text-dark">No hay requisitos documentales cargados</p>
                    <p class="small text-muted m-0">
                        @if (canComplementDocuments) {
                            Puede complementar la solicitud con documentos opcionales del catálogo.
                        } @else {
                            No se encontraron requisitos documentales para esta incorporación.
                        }
                    </p>
                </div>
            }

            @if (canComplementDocuments) {
                <div class="row g-2 align-items-end mt-3 border-top pt-3">
                    <div class="col-sm-8 col-12">
                        <label class="form-label small fw-bold text-muted mb-1">Complementar solicitud</label>
                        <app-sheet-select
                            [items]="complementaryOptions"
                            bindLabel="name"
                            bindValue="key"
                            title="Documento complementario"
                            placeholder="Seleccione documento..."
                            [(ngModel)]="selectedComplementKey"
                            [clearable]="true"
                            [searchable]="complementaryOptions.length > 5">
                        </app-sheet-select>
                    </div>
                    <div class="col-sm-4 col-12 text-end">
                        <button type="button" class="btn btn-outline-primary btn-sm w-100"
                            [disabled]="!selectedComplementKey"
                            (click)="addComplementaryDocument()">
                            <i class="fas fa-plus me-1"></i> Agregar
                        </button>
                    </div>
                </div>
            }
        }
    </div>

    @if (!appSettings.isMobile()) {
        <div class="step-footer">
            <div>
                @if (tab > 1) {
                    <button class="btn btn-outline-secondary btn-sm px-3" (click)="tab = tab - 1">
                        <i class="fas fa-chevron-left me-1"></i> Anterior
                    </button>
                }
            </div>
            <div class="d-flex flex-wrap align-items-center justify-content-end gap-2">
                @if (mode !== FormMode.VIEW && isDraftRequest && activeRequest) {
                    <button class="btn btn-outline-danger btn-sm" (click)="deleteRequestApproval()" [disabled]="isSaving">
                        <i class="fas fa-trash-alt me-1"></i> Desechar borrador
                    </button>
                }
                <button class="btn btn-danger btn-sm" (click)="changeTabShow(0)">
                    <i class="fas fa-times me-1"></i> {{ mode === FormMode.VIEW ? 'Cerrar' : 'Cancelar' }}
                </button>
                @if (mode !== FormMode.VIEW) {
                    @if (tab === 1) {
                        <button class="btn btn-primary btn-sm" (click)="submitParty(tab)" [disabled]="!partyForm?.valid && party">
                            <i class="fas fa-save me-1"></i> Guardar y continuar
                        </button>
                    }
                    @if (tab === 2) {
                        <button class="btn btn-primary btn-sm" (click)="submitVehicle(tab)">
                            <i class="fas fa-save me-1"></i> Guardar y continuar
                        </button>
                    }
                    @if (tab === 3 && isDraftRequest && activeRequest) {
                        @if (!areAllDocumentsUploaded) {
                            <span class="text-muted small">Cargue todos los documentos para enviar</span>
                        } @else {
                            <button class="btn btn-success btn-sm" (click)="submitRequestApproval()" [disabled]="isSaving">
                                @if (isSaving) {
                                    <span class="spinner-border spinner-border-sm me-1"></span>
                                }
                                <i class="fas fa-paper-plane me-1"></i> Enviar solicitud
                            </button>
                        }
                    }
                    @if (tab === 3 && !isDraftRequest) {
                        <button class="btn btn-primary btn-sm" (click)="changeTabShow(0)">
                            <i class="fas fa-check me-1"></i> Finalizar
                        </button>
                    }
                } @else if (tab < 3) {
                    <button class="btn btn-primary btn-sm" (click)="tab = tab + 1">
                        Siguiente <i class="fas fa-chevron-right ms-1"></i>
                    </button>
                }
            </div>
        </div>
    }
</div>

<app-viewer *ngIf="isViewerOpen"
   [items]="viewerItems"
   [activeId]="activeViewerId"
   (onSelect)="activeViewerId = $event"
   (close)="isViewerOpen = false">
</app-viewer>

<app-mobile-footer [visible]="!!headerEditorAction() || canDeleteFromHeader() || canSubmitPartyFromFooter()">
    @if (canDeleteFromHeader()) {
        <button type="button" class="btn btn-outline-danger btn-sm"
            [disabled]="isSaving"
            (click)="deleteFromHeader()">
            <i class="fas fa-trash-alt me-1"></i>Desechar
        </button>
    }
    @if (headerEditorAction(); as action) {
        <button type="button" class="btn btn-sm"
            [class.btn-success]="action === 'finalize'"
            [class.btn-primary]="action !== 'finalize'"
            [disabled]="isSaving"
            (click)="saveEditorFromHeader()">
            @if (isSaving) {
                <span class="spinner-border spinner-border-sm me-1"></span>
            }
            @if (action === 'finalize') {
                Finalizar
            } @else if (action === 'next') {
                Siguiente
            } @else {
                Guardar
            }
        </button>
    } @else if (canSubmitPartyFromFooter()) {
        <button type="button" class="btn btn-success btn-sm"
            [disabled]="isSaving"
            (click)="submitRequestApproval()">
            @if (isSaving) {
                <span class="spinner-border spinner-border-sm me-1"></span>
            }
            Enviar
        </button>
    }
</app-mobile-footer>
